if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}

					const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					const productFigures = this.querySelectorAll('.apply-gallery-animation');
					this.productSlider.addEventListener('scroll', ()=>{
						const scrollX = -this.productSlider.element.scrollLeft;
						productSlides.forEach((slide,i)=>{
							const media = productFigures[i];
							if ( media ) {
								media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
							}
						});
					});

				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

			this.cleanupDuplicateDescriptionHeadings();
			this.initWishlistShareTrigger();

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

			onVariantChangeHandler(e){

				let variant = e.target.currentVariant;
				this.syncFreeShippingBenefit(variant);
				if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
					}

				}

				this.initializeWishlistShareTrigger();

			}

			syncFreeShippingBenefit(variant){

				const benefit = this.querySelector('[data-spirit-free-shipping]');
				if ( ! benefit || ! variant ) {
					return;
				}

				const threshold = Number(benefit.dataset.freeShippingThreshold);
				const price = Number(variant.price);
				if ( ! Number.isFinite(threshold) || threshold <= 0 || ! Number.isFinite(price) ) {
					return;
				}

				const isIncluded = price >= threshold;
				const label = benefit.querySelector('[data-free-shipping-label]');
				const copy = isIncluded
					? benefit.dataset.freeShippingIncludedLabel
					: benefit.dataset.freeShippingDefaultLabel;

				benefit.classList.toggle('spirit-delivery__benefit--free-shipping-included', isIncluded);
				if ( label && copy ) {
					label.textContent = copy;
				}

			}

		cleanupDuplicateDescriptionHeadings(){

			this.querySelectorAll('[data-product-description][data-hide-duplicate-title-heading="true"]').forEach((description)=>{
				if ( description.dataset.descriptionHeadingCleaned == 'true' ) {
					return;
				}

				const normalizedTitle = this.normalizeDescriptionText(description.dataset.productTitle || '');
				if ( ! normalizedTitle ) {
					return;
				}

				const initialElements = Array.from(description.children).slice(0, 4);
				const duplicateHeading = initialElements.find((element)=>{
					return /^H[1-3]$/.test(element.tagName);
				});

				if ( ! duplicateHeading ) {
					return;
				}

				const normalizedHeading = this.normalizeDescriptionText(duplicateHeading.textContent || '');
				if ( normalizedHeading !== normalizedTitle ) {
					return;
				}

				duplicateHeading.remove();
				description.dataset.descriptionHeadingCleaned = 'true';
			});

		}

			initWishlistShareTrigger(){

				this.wishlistShareTrigger = this.querySelector('[data-js-wishlist-share-trigger]');
				if ( ! this.wishlistShareTrigger ) {
					return;
				}

				this.wishlistShareTransport = false;
				this.wishlistShareHash = false;
				this.onWishlistSdkReadyHandler = this.onWishlistSdkReady.bind(this);
				document.addEventListener('wishlist-hero-wishlist-sdk-ready', this.onWishlistSdkReadyHandler);
				this.syncWishlistShareTrigger();

				this.initializeWishlistShareTrigger();

			}

			onWishlistSdkReady(){
				this.initializeWishlistShareTrigger();
			}

			hasWishlistShareSdk(){
				return Boolean(
					window.WishListHero_SDK &&
					typeof window.WishListHero_SDK.GetWishListHash === 'function' &&
					typeof window.WishListHero_SDK.GetWishListItems === 'function' &&
					typeof window.WishListHero_SDK.AddWishListItem === 'function' &&
					typeof window.WishListHero_SDK.DeleteWishListItem === 'function'
				);
			}

			getWishlistShareVariantImage(variant){
				if ( ! variant || ! variant.featured_image ) {
					return '';
				}

				if ( typeof variant.featured_image == 'string' ) {
					return variant.featured_image;
				}

				return variant.featured_image.src || variant.featured_image.url || '';
			}

			normalizeWishlistShareImage(image=''){
				if ( ! image ) {
					return '';
				}

				return image.replace(/^https?:/, '');
			}

			getWishlistShareStoreConfig(){
				return window.WishListHero_setting || {};
			}

			getWishlistShareStorageKey(key){
				return `wishlisthero_.${key}`;
			}

			getWishlistShareStorageValue(key, fallbackValue=null){
				try {
					const rawValue = window.localStorage.getItem(this.getWishlistShareStorageKey(key));
					return rawValue ? JSON.parse(rawValue) : fallbackValue;
				} catch ( error ) {
					return fallbackValue;
				}
			}

			setWishlistShareStorageValue(key, value){
				try {
					window.localStorage.setItem(this.getWishlistShareStorageKey(key), JSON.stringify(value));
				} catch ( error ) {}
			}

			getWishlistShareCustomerId(){
				const storedCustomerId = this.getWishlistShareStorageValue('c-id', null);
				if ( storedCustomerId !== null && storedCustomerId !== '' ) {
					return storedCustomerId;
				}

				if (
					window.ShopifyAnalytics &&
					window.ShopifyAnalytics.meta &&
					window.ShopifyAnalytics.meta.page &&
					window.ShopifyAnalytics.meta.page.customerId
				) {
					return window.ShopifyAnalytics.meta.page.customerId;
				}

				return null;
			}

			setWishlistShareCustomerId(customerId=null){
				this.setWishlistShareStorageValue('c-id', customerId);
			}

			getWishlistShareHash(){
				return this.getWishlistShareStorageValue('wl-h', null);
			}

			getWishlistShareItems(){
				return this.getWishlistShareStorageValue('wl-itms', []);
			}

			setWishlistShareItems(items=[]){
				this.setWishlistShareStorageValue('wl-itms', items);
			}

			getWishlistShareApiBaseUrl(){
				return 'https://wishlist-hero.revampco.com/storefront/api/store';
			}

			getWishlistShareShop(){
				const storeConfig = this.getWishlistShareStoreConfig();
				return (
					storeConfig.Shop ||
					storeConfig.shop ||
					(window.Shopify && window.Shopify.shop) ||
					''
				);
			}

			async ensureWishlistShareHash(){
				const existingHash = this.getWishlistShareHash();
				if ( existingHash ) {
					return existingHash;
				}

				const shop = this.getWishlistShareShop();
				if ( ! shop ) {
					throw new Error('Wishlist Hero shop missing.');
				}

				const response = await fetch(`${this.getWishlistShareApiBaseUrl()}/${shop}/wishlist`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						CustomerId: this.getWishlistShareCustomerId()
					})
				});
				const data = await response.json();
				const wishlist = data && data.wishlist ? data.wishlist : null;
				const wishlistHash = wishlist && wishlist.Hash ? wishlist.Hash : null;

				if ( ! response.ok || ! data || data.ok !== true || ! wishlistHash ) {
					throw new Error('Wishlist Hero hash creation failed.');
				}

				this.setWishlistShareStorageValue('wl-h', wishlistHash);
				this.setWishlistShareItems(Array.isArray(wishlist.Items) ? wishlist.Items : []);
				if ( typeof wishlist.StoreCustomerId !== 'undefined' ) {
					this.setWishlistShareCustomerId(wishlist.StoreCustomerId);
				}

				return wishlistHash;
			}

			dispatchWishlistShareUpdated(detail={}){
				document.dispatchEvent(new CustomEvent('wishlist-hero-wishlist-updated', { detail }));
			}

			buildWishlistShareStoredItem(buttonInfo){
				return {
					AddedOn: new Date().toISOString(),
					Price: buttonInfo.ProductPrice,
					ProductId: String(buttonInfo.ProductId),
					ProductImage: buttonInfo.ProductImage,
					ProductLink: buttonInfo.ProductLink,
					ProductName: buttonInfo.ProductTitle,
					ProductVariantId: String(buttonInfo.ProductVariantId)
				};
			}

			updateWishlistShareItems(buttonInfo, isSaved){
				const variantId = String(buttonInfo.ProductVariantId);
				const currentItems = this.getWishlistShareItems().filter((item)=>{
					return String(item.ProductVariantId || item.productVariantId || '') !== variantId;
				});

				if ( isSaved ) {
					currentItems.push(this.buildWishlistShareStoredItem(buttonInfo));
				}

				this.setWishlistShareItems(currentItems);
				this.dispatchWishlistShareUpdated(isSaved ? { added: variantId } : { removed: variantId });
			}

			escapeWishlistShareText(value=''){
				return String(value)
					.replace(/&/g, '&amp;')
					.replace(/</g, '&lt;')
					.replace(/>/g, '&gt;')
					.replace(/"/g, '&quot;')
					.replace(/'/g, '&#039;');
			}

			getWishlistShareTexts(){
				const storeConfig = this.getWishlistShareStoreConfig();
				const removeEnabled = typeof storeConfig.EnableRemoveFromWishlistAfterAdd === 'boolean'
					? storeConfig.EnableRemoveFromWishlistAfterAdd
					: true;
				const customAddLabel = this.wishlistShareTrigger.dataset.wishlistAddLabel || '';
				const customSavedLabel = this.wishlistShareTrigger.dataset.wishlistSavedLabel || '';
				const customRemoveLabel = this.wishlistShareTrigger.dataset.wishlistRemoveLabel || '';
				const defaultAddLabel = customAddLabel || 'Merkliste';
				const defaultRemoveLabel = customRemoveLabel || 'Von Merkliste entfernen';
				const defaultSavedLabel = customSavedLabel || (removeEnabled
					? 'Von Merkliste entfernen'
					: 'Zur Merkliste hinzugef\u00fcgt');

				return {
					addLabel: customAddLabel || storeConfig.ButtonTextBeforeAdding || defaultAddLabel,
					savedLabel: customSavedLabel || (
						removeEnabled
							? storeConfig.EnableRemoveFromWishlistAfterAddButtonText || defaultSavedLabel
							: storeConfig.ButtonTextAfterAdding || defaultSavedLabel
					),
					removeLabel: customRemoveLabel || storeConfig.EnableRemoveFromWishlistAfterAddButtonText || defaultRemoveLabel,
					removeEnabled: removeEnabled
				};
			}

			renderWishlistShareButton(isSaved=false, isDisabled=false){
				if ( ! this.wishlistShareTrigger ) {
					return;
				}

				const texts = this.getWishlistShareTexts();
				const label = isSaved ? texts.savedLabel : texts.addLabel;
				const actionLabel = isSaved && texts.removeEnabled ? texts.removeLabel : label;
				const pressedState = isSaved ? 'true' : 'false';
				const interactionDisabled = isDisabled || (isSaved && ! texts.removeEnabled);
				const disabledAttribute = interactionDisabled ? ' disabled' : '';
				const activeClass = isSaved ? ' product-sharing__wishlist-button--saved' : '';
				const safeLabel = this.escapeWishlistShareText(label);
				const safeActionLabel = this.escapeWishlistShareText(actionLabel);

				this.wishlistShareTrigger.innerHTML = `
					<button
						type="button"
						class="product-sharing__wishlist-button${activeClass}"
						aria-label="${safeActionLabel}"
						aria-pressed="${pressedState}"${disabledAttribute}
					>
						<span aria-hidden="true" class="text-with-icon__icon product-sharing__wishlist-icon">
							<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6 3.5H18C18.5523 3.5 19 3.94772 19 4.5V21L12 16.5L5 21V4.5C5 3.94772 5.44772 3.5 6 3.5Z" />
							</svg>
						</span>
						<span class="text-animation--underline-thin">${safeLabel}</span>
					</button>
				`;

				this.wishlistShareButton = this.wishlistShareTrigger.querySelector('button');
				if ( this.wishlistShareButton && ! interactionDisabled ) {
					this.wishlistShareButton.addEventListener('click', this.onWishlistShareClick.bind(this));
				}

				this.wishlistShareTrigger.setAttribute('aria-busy', 'false');
				this.wishlistShareTrigger.classList.add('product-sharing__wishlist-trigger--ready');
			}

			async fetchWishlistShareSavedState(buttonInfo, wishlistHash){
				if ( ! buttonInfo || ! wishlistHash ) {
					return false;
				}

				const variantId = String(buttonInfo.ProductVariantId);
				const cachedItems = this.getWishlistShareItems();
				if ( cachedItems.some((item)=>{
					return String(item.ProductVariantId || item.productVariantId || '') === variantId;
				}) ) {
					return true;
				}

				const shop = this.getWishlistShareShop();
				if ( ! shop ) {
					return false;
				}

				const response = await fetch(`${this.getWishlistShareApiBaseUrl()}/${shop}/wishlist/${wishlistHash}/has/${variantId}`);
				const data = await response.json();
				return Boolean(data && data.exists);
			}

			getWishlistShareSdkItems(){
				if ( ! this.hasWishlistShareSdk() ) {
					return [];
				}

				const items = window.WishListHero_SDK.GetWishListItems();
				return Array.isArray(items) ? items : [];
			}

			isWishlistShareItemSaved(items, buttonInfo){
				if ( ! Array.isArray(items) || ! buttonInfo ) {
					return false;
				}

				const variantId = String(buttonInfo.ProductVariantId);
				return items.some((item)=>{
					return String(item.ProductVariantId || item.productVariantId || '') === variantId;
				});
			}

			async addWishlistShareSdkItem(buttonInfo, wishlistHash){
				const productInfo = {
					ProductId: buttonInfo.ProductId,
					ProductTitle: buttonInfo.ProductTitle,
					ProductPrice: buttonInfo.ProductPrice,
					ProductLink: buttonInfo.ProductLink,
					ProductVariantId: buttonInfo.ProductVariantId,
					ProductImage: buttonInfo.ProductImage,
					WishlistHash: wishlistHash
				};
				const customerId = this.getWishlistShareCustomerId();
				if ( customerId !== null && customerId !== '' ) {
					productInfo.CustomerId = customerId;
				}

				const result = await window.WishListHero_SDK.AddWishListItem(productInfo);
				this.updateWishlistShareItems(buttonInfo, true);
				return result;
			}

			async deleteWishlistShareSdkItem(buttonInfo, wishlistHash){
				const result = await window.WishListHero_SDK.DeleteWishListItem({
					ProductVariantId: buttonInfo.ProductVariantId,
					WishlistHash: wishlistHash
				});
				this.updateWishlistShareItems(buttonInfo, false);
				return result;
			}

			async addWishlistShareRestItem(buttonInfo, wishlistHash){
				const shop = this.getWishlistShareShop();
				if ( ! shop ) {
					throw new Error('Wishlist Hero shop missing.');
				}

				const payload = {
					customerId: this.getWishlistShareCustomerId(),
					productId: buttonInfo.ProductId,
					productName: buttonInfo.ProductTitle,
					productPrice: buttonInfo.ProductPrice,
					productLink: buttonInfo.ProductLink,
					productVariantId: buttonInfo.ProductVariantId,
					productImage: buttonInfo.ProductImage,
					AddedVia: 'SDK'
				};

				const response = await fetch(`${this.getWishlistShareApiBaseUrl()}/${shop}/wishlist/${wishlistHash}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(payload)
				});
				const data = await response.json();

				if ( ! response.ok || ! data || data.ok !== true ) {
					throw new Error('Wishlist Hero add failed.');
				}

				this.updateWishlistShareItems(buttonInfo, true);
				return data;
			}

			async deleteWishlistShareRestItem(buttonInfo, wishlistHash){
				const shop = this.getWishlistShareShop();
				if ( ! shop ) {
					throw new Error('Wishlist Hero shop missing.');
				}

				const variantId = String(buttonInfo.ProductVariantId);
				const response = await fetch(`${this.getWishlistShareApiBaseUrl()}/${shop}/wishlist/${wishlistHash}/delete/${variantId}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					}
				});
				const data = await response.json();

				if ( ! response.ok || ! data || data.ok !== true ) {
					throw new Error('Wishlist Hero delete failed.');
				}

				this.updateWishlistShareItems(buttonInfo, false);
				return data;
			}

			async onWishlistShareClick(e){
				e.preventDefault();

				if ( this.wishlistSharePending ) {
					return;
				}

				const buttonInfo = this.buildWishlistShareButtonInfo();
				if ( ! buttonInfo ) {
					return;
				}

				const wishlistButton = this.wishlistShareTrigger ? this.wishlistShareTrigger.querySelector('button') : null;
				const isSaved = wishlistButton ? wishlistButton.getAttribute('aria-pressed') === 'true' : false;
				const removeEnabled = this.getWishlistShareTexts().removeEnabled;
				if ( isSaved && ! removeEnabled ) {
					return;
				}

				this.wishlistSharePending = true;
				this.wishlistShareTrigger.setAttribute('aria-busy', 'true');
				if ( wishlistButton ) {
					wishlistButton.disabled = true;
				}

				try {
					if ( this.wishlistShareTransport === 'sdk' && this.hasWishlistShareSdk() ) {
						const wishlistHash = this.wishlistShareHash || await window.WishListHero_SDK.GetWishListHash(true);
						this.wishlistShareHash = wishlistHash;
						if ( isSaved ) {
							await this.deleteWishlistShareSdkItem(buttonInfo, wishlistHash);
						} else {
							await this.addWishlistShareSdkItem(buttonInfo, wishlistHash);
						}
					} else {
						const wishlistHash = this.wishlistShareHash || await this.ensureWishlistShareHash();
						this.wishlistShareHash = wishlistHash;
						if ( isSaved ) {
							await this.deleteWishlistShareRestItem(buttonInfo, wishlistHash);
						} else {
							await this.addWishlistShareRestItem(buttonInfo, wishlistHash);
						}
					}

					const currentButtonInfo = this.buildWishlistShareButtonInfo();
					if ( currentButtonInfo && currentButtonInfo.ProductVariantId === buttonInfo.ProductVariantId ) {
						this.renderWishlistShareButton(! isSaved);
					} else {
						this.wishlistShareCurrentKey = false;
						await this.initializeWishlistShareTrigger();
					}
				} catch ( error ) {
					console.error('Wishlist Hero action failed.', error);
					const currentButtonInfo = this.buildWishlistShareButtonInfo();
					if ( currentButtonInfo && currentButtonInfo.ProductVariantId === buttonInfo.ProductVariantId ) {
						this.renderWishlistShareButton(isSaved);
					}
				} finally {
					this.wishlistSharePending = false;
					this.wishlistShareTrigger.setAttribute('aria-busy', 'false');
				}
			}

			async initializeWishlistShareRestFallback(buttonInfo=false){
				if ( ! this.wishlistShareTrigger ) {
					return;
				}

				const resolvedButtonInfo = buttonInfo || this.buildWishlistShareButtonInfo();
				if ( ! resolvedButtonInfo ) {
					this.resetWishlistShareTrigger();
					this.wishlistShareTrigger.setAttribute('aria-busy', 'false');
					return;
				}

				const variantKey = [
					'rest',
					resolvedButtonInfo.ProductId,
					resolvedButtonInfo.ProductVariantId,
					resolvedButtonInfo.ProductPrice,
					resolvedButtonInfo.ProductImage
				].join(':');

				if ( this.wishlistShareCurrentKey === variantKey && this.wishlistShareTrigger.querySelector('button') ) {
					this.syncWishlistShareTrigger();
					return;
				}

				if ( this.wishlistShareInitializingKey === variantKey ) {
					return;
				}

				this.wishlistShareRequestedKey = variantKey;
				this.wishlistShareInitializingKey = variantKey;
				this.resetWishlistShareTrigger();

				try {
					const wishlistHash = await this.ensureWishlistShareHash();
					const isSaved = await this.fetchWishlistShareSavedState(resolvedButtonInfo, wishlistHash);
					if ( this.wishlistShareRequestedKey !== variantKey ) {
						return;
					}
					this.wishlistShareTransport = 'rest';
					this.wishlistShareHash = wishlistHash;
					this.renderWishlistShareButton(isSaved);
					this.wishlistShareCurrentKey = variantKey;
				} catch ( error ) {
					if ( this.wishlistShareRequestedKey === variantKey ) {
						console.error('Wishlist Hero REST fallback initialization failed.', error);
						this.renderWishlistShareButton(false, true);
						this.wishlistShareCurrentKey = false;
						this.wishlistShareTransport = false;
					}
				} finally {
					if ( this.wishlistShareInitializingKey === variantKey ) {
						this.wishlistShareInitializingKey = false;
					}
				}
			}

			resetWishlistShareTrigger(){
				if ( ! this.wishlistShareTrigger ) {
					return;
				}

				this.wishlistShareTrigger.innerHTML = '';
				this.wishlistShareTrigger.setAttribute('aria-busy', 'true');
				this.wishlistShareTrigger.classList.remove('product-sharing__wishlist-trigger--ready');
				Array.from(this.wishlistShareTrigger.attributes).forEach((attribute)=>{
					if ( attribute.name.indexOf('data-wlh-') === 0 ) {
						this.wishlistShareTrigger.removeAttribute(attribute.name);
					}
				});
				Array.from(this.wishlistShareTrigger.classList).forEach((className)=>{
					if ( className.indexOf('wishlisthero-') === 0 ) {
						this.wishlistShareTrigger.classList.remove(className);
					}
				});
			}

			buildWishlistShareButtonInfo(){
				if ( ! this.wishlistShareTrigger ) {
					return false;
				}

				const variant = this.productVariants ? this.productVariants.currentVariant : false;
				const productId = parseInt(this.wishlistShareTrigger.dataset.productId || this.dataset.id || 0);
				const variantId = variant && variant.id ? parseInt(variant.id) : 0;
				const productPrice = variant && variant.price ? parseFloat(variant.price) / 100 : 0;

				if ( ! productId || ! variantId ) {
					return false;
				}

				const link = new URL(this.wishlistShareTrigger.dataset.productUrl || window.location.pathname, window.location.origin);
				link.searchParams.set('variant', variantId);

				const title = variant && variant.name ? variant.name : this.wishlistShareTrigger.dataset.productTitle || document.title;
				const image = this.normalizeWishlistShareImage(
					this.getWishlistShareVariantImage(variant) || this.wishlistShareTrigger.dataset.productImage || ''
				);

				return {
					ProductId: productId,
					ProductLink: link.toString(),
					ProductVariantId: variantId,
					ProductPrice: productPrice,
					ProductTitle: title,
					ProductImage: image
				};
			}

			syncWishlistShareTrigger(){

				if ( ! this.wishlistShareTrigger ) {
					return;
				}

				const wishlistTarget = this.wishlistShareTrigger.querySelector('button, a');
				const isReady = Boolean(wishlistTarget);

				this.wishlistShareTrigger.setAttribute('aria-busy', isReady ? 'false' : 'true');
				this.wishlistShareTrigger.classList.toggle('product-sharing__wishlist-trigger--ready', isReady);

			}

			async initializeWishlistShareTrigger(){

				if ( ! this.wishlistShareTrigger ) {
					return;
				}

				if ( ! this.hasWishlistShareSdk() ) {
					await this.initializeWishlistShareRestFallback();
					return;
				}

				const buttonInfo = this.buildWishlistShareButtonInfo();
				if ( ! buttonInfo ) {
					this.resetWishlistShareTrigger();
					this.wishlistShareCurrentKey = false;
					this.syncWishlistShareTrigger();
					return;
				}

				const variantKey = [
					'sdk',
					buttonInfo.ProductId,
					buttonInfo.ProductVariantId,
					buttonInfo.ProductPrice,
					buttonInfo.ProductImage
				].join(':');

				if ( this.wishlistShareCurrentKey === variantKey && this.wishlistShareTrigger.querySelector('button, a') ) {
					this.syncWishlistShareTrigger();
					return;
				}

				if ( this.wishlistShareInitializingKey === variantKey ) {
					return;
				}

				this.wishlistShareRequestedKey = variantKey;
				this.wishlistShareInitializingKey = variantKey;
				this.resetWishlistShareTrigger();

				try {
					const wishlistHash = await window.WishListHero_SDK.GetWishListHash(true);
					const wishlistItems = this.getWishlistShareSdkItems();
					if ( this.wishlistShareRequestedKey !== variantKey ) {
						return;
					}
					this.wishlistShareTransport = 'sdk';
					this.wishlistShareHash = wishlistHash;
					this.setWishlistShareItems(wishlistItems);
					this.renderWishlistShareButton(this.isWishlistShareItemSaved(wishlistItems, buttonInfo));
					this.wishlistShareCurrentKey = variantKey;
				} catch ( error ) {
					if ( this.wishlistShareRequestedKey === variantKey ) {
						this.wishlistShareCurrentKey = false;
						this.wishlistShareTransport = false;
						console.error('Wishlist Hero SDK initialization failed.', error);
						this.wishlistShareInitializingKey = false;
						await this.initializeWishlistShareRestFallback(buttonInfo);
					}
				} finally {
					if ( this.wishlistShareInitializingKey === variantKey ) {
						this.wishlistShareInitializingKey = false;
					}
				}

			}

		normalizeDescriptionText(value=''){
			const safeValue = typeof value.normalize === 'function'
				? value.normalize('NFKC')
				: value;

			return safeValue
				.replace(/\u00A0/g, ' ')
				.replace(/\s+/g, ' ')
				.trim()
				.toLowerCase();
		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

	class PaymentMethodTooltips extends HTMLElement {

		constructor(){
			super();
			this.onTooltipClickHandler = this.onTooltipClick.bind(this);
			this.onTooltipFocusInHandler = this.onTooltipFocusIn.bind(this);
			this.onTooltipFocusOutHandler = this.onTooltipFocusOut.bind(this);
			this.onTooltipPointerOutHandler = this.onTooltipPointerOut.bind(this);
			this.onDocumentClickHandler = this.onDocumentClick.bind(this);
			this.onDocumentKeydownHandler = this.onDocumentKeydown.bind(this);
		}

		connectedCallback(){
			if ( this.paymentTooltipsConnected ) {
				return;
			}

			this.paymentTooltipsConnected = true;
			this.addEventListener('click', this.onTooltipClickHandler);
			this.addEventListener('focusin', this.onTooltipFocusInHandler);
			this.addEventListener('focusout', this.onTooltipFocusOutHandler);
			this.addEventListener('pointerout', this.onTooltipPointerOutHandler);
			document.addEventListener('click', this.onDocumentClickHandler);
			document.addEventListener('keydown', this.onDocumentKeydownHandler);
		}

		disconnectedCallback(){
			this.paymentTooltipsConnected = false;
			this.removeEventListener('click', this.onTooltipClickHandler);
			this.removeEventListener('focusin', this.onTooltipFocusInHandler);
			this.removeEventListener('focusout', this.onTooltipFocusOutHandler);
			this.removeEventListener('pointerout', this.onTooltipPointerOutHandler);
			document.removeEventListener('click', this.onDocumentClickHandler);
			document.removeEventListener('keydown', this.onDocumentKeydownHandler);
		}

		getTooltipTrigger(target){
			if ( ! target || typeof target.closest !== 'function' ) {
				return false;
			}

			const trigger = target.closest('[data-payment-tooltip-trigger]');
			return trigger && this.contains(trigger) ? trigger : false;
		}

		closeTooltips(except=false){
			this.querySelectorAll('[data-payment-tooltip-trigger]').forEach((trigger)=>{
				if ( trigger !== except ) {
					trigger.removeAttribute('data-payment-tooltip-open');
				}
			});
		}

		onTooltipClick(event){
			const trigger = this.getTooltipTrigger(event.target);
			if ( ! trigger ) {
				return;
			}

			const shouldOpen = ! trigger.hasAttribute('data-payment-tooltip-open');
			this.closeTooltips();
			trigger.removeAttribute('data-payment-tooltip-dismissed');
			if ( shouldOpen ) {
				trigger.setAttribute('data-payment-tooltip-open', 'true');
			}
		}

		onTooltipFocusIn(event){
			const trigger = this.getTooltipTrigger(event.target);
			if ( trigger ) {
				trigger.removeAttribute('data-payment-tooltip-dismissed');
				this.closeTooltips(trigger);
			}
		}

		onTooltipFocusOut(event){
			if ( event.relatedTarget && this.contains(event.relatedTarget) ) {
				return;
			}

			this.closeTooltips();
			this.querySelectorAll('[data-payment-tooltip-dismissed]').forEach((trigger)=>{
				trigger.removeAttribute('data-payment-tooltip-dismissed');
			});
		}

		onTooltipPointerOut(event){
			const trigger = this.getTooltipTrigger(event.target);
			if ( ! trigger || this.getTooltipTrigger(event.relatedTarget) === trigger ) {
				return;
			}

			const keepsKeyboardFocus = trigger === document.activeElement && trigger.matches(':focus-visible');
			if ( ! keepsKeyboardFocus ) {
				trigger.removeAttribute('data-payment-tooltip-dismissed');
			}
		}

		getVisibleTooltipTriggers(){
			return Array.from(this.querySelectorAll('[data-payment-tooltip-trigger]')).filter((trigger)=>{
				const tooltip = trigger.querySelector('.spirit-delivery__payment-tooltip');
				if ( ! tooltip ) {
					return false;
				}

				const tooltipStyles = window.getComputedStyle(tooltip);
				return tooltipStyles.visibility !== 'hidden' && tooltipStyles.opacity !== '0';
			});
		}

		onDocumentKeydown(event){
			if ( event.key !== 'Escape' ) {
				return;
			}

			const visibleTriggers = this.getVisibleTooltipTriggers();
			if ( visibleTriggers.length === 0 ) {
				return;
			}

			this.closeTooltips();
			visibleTriggers.forEach((trigger)=>{
				trigger.setAttribute('data-payment-tooltip-dismissed', 'true');
			});
			event.preventDefault();
		}

		onDocumentClick(event){
			if ( ! this.contains(event.target) ) {
				this.closeTooltips();
			}
		}

	}

	if ( typeof customElements.get('payment-method-tooltips') == 'undefined' ) {
		customElements.define('payment-method-tooltips', PaymentMethodTooltips);
	}

}
